import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Odbiór',
        [ORDER_METHODS.DELIVERY]: 'Dostawa',
        [ORDER_METHODS.ROOM_SERVICE]: {
          [RoomServiceLocationType.RoomService]: 'Obsługa pokoju',
          [RoomServiceLocationType.TableService]: 'Obsługa przy stole',
        },
      },
    },
    delivery_info: {
      title: 'Szczegóły dostawy',
      on_arrival: 'Po przybyciu:',
    },
    customer_info: {
      title: 'Kontakt',
    },
    payment: {
      title: 'Płatność',
    },
    request_invoice: {
      title: 'Zamów fakturę',
      form: {
        is_receipt_required: {
          label: 'Zamów fakturę e-mailem',
        },
      },
    },
    location: {
      title: 'Adres sklepu',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Adres dostawy',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'Adres na miejscu',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Adres odbioru',
      },
    },
    method: {
      title: 'Metoda',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Dostawa',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'Na miejscu',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Odbiór',
      },
    },
    time: {
      title: 'Czas',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Standard {{time}} min, Dzisiaj',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Zaplanuj na później',
        },
      },
    },
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Numer pokoju',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Numer stolika',
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Zadzwoń do drzwi',
        [DropoffAction.Sms]: 'Skontaktuj się ze mną przez SMS po przybyciu',
      },
    },
    doorbell_name: {
      placeholder: 'Nazwa dzwonka (opcjonalnie)',
    },
    company_name: {
      placeholder: 'Nazwa firmy (opcjonalnie)',
    },
    customer_note: {
      placeholder: 'Instrukcje dostawy (opcjonalnie)',
    },
    order_instructions: {
      placeholder: 'Wpisz instrukcje do zamówienia...',
    },
  },
  buttons: {
    change: 'Zmień',
    edit: 'Edytuj',
    done: 'Gotowe',
    add_delivery_note: '+ Dodaj szczegóły dostawy',
    add_order_instructions: '+ Dodaj instrukcje do zamówienia',
  },
  summary: {
    doorbell: 'Dzwonek',
    company: 'Firma',
    note: 'Uwaga',
    instructions: 'Instrukcje',
  },
};
